import { useAuthContext } from '~/auth/auth.context';

import { getSettingsPermissions, type SettingsPermissions } from './settingsPermissions';

export type { SettingsPermissions };

type AuthLike = {
  userId: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
};

export function useSettingsPermissions(
  authData: AuthLike,
  targetUserId: string,
): SettingsPermissions {
  const [{ impersonation }] = useAuthContext();
  return getSettingsPermissions(authData, targetUserId, impersonation != null);
}

/**
 * Convenience hook for "can this user act as an admin?" — true for admins,
 * superadmins, and anyone impersonating (only superadmins can impersonate).
 *
 * Use this to gate UI that lets the user act on other team members' data:
 * owner-filter dropdowns, "assign to" pickers, etc. Regular users should be
 * locked to acting on their own data only.
 */
export function useIsAdminLike(): boolean {
  const [auth] = useAuthContext();
  if (auth.impersonation != null) return true;
  const userTeam = 'userTeam' in auth ? auth.userTeam : null;
  return Boolean(userTeam?.isAdmin || userTeam?.isSuperAdmin);
}
